define('shared/initializer/form/adapters/mixins/PaymentOfferIdSubmittable',[
    '$',
    'shared/lib/RSVP',
    'shared/util/state',
    'shared/util/state/adapters/order',
    'shared/initializer/form/constants',
    'shared/util/dispatchers/FormDataDispatcher'
], 
function (
    $,
    RSVP,
    state,
    orderAdapter,
    constants,
    FormDataDispatcher
) {
    'use strict';

    var NEW_LIFECYCLE_NAME = 'doBeforeRetrievingOffersForSubmission';

    function Ctor() { 
        this.lifeCycles.push(NEW_LIFECYCLE_NAME);
    }

    Ctor.prototype.doBeforeSubmit = function () {
        var me = this;

        return RSVP.resolve()
            .then(function(){
                return state.adapters.add(orderAdapter);
            })
            .then(function(){
                if (typeof me[NEW_LIFECYCLE_NAME] === 'function') {
                    return me[NEW_LIFECYCLE_NAME]();
                }
            })
            .then(function(offerIds){
                var dispatcher = new FormDataDispatcher(me.$form);
                var items = {};
                items[constants.State.OrderOfferId] = {
                    sources:
                    [{
                        retrieve: function() {
                            if (Array.isArray(offerIds) && offerIds.length > 0) {
                                return state.push(constants.State.OrderOfferId, offerIds)
                                    .then(function(){
                                        if (
                                            offerIds.length <= 0 || 
                                            !offerIds[0]
                                        ) {
                                            console.warn('Payment: cannot find order.offer_id in state object.');
                                            return RSVP.reject('Payment: cannot find order.offer_id in state object.');
                                        }
                                        return offerIds;
                                    });
                            }
                            else {
                                return state.retrieve(constants.State.OrderOfferId)
                                    .then(function(offerId){
                                        if (!offerId) {
                                            console.warn('Payment: cannot find order.offer_id in state object.');
                                            return RSVP.reject('Payment: cannot find order.offer_id in state object.');
                                        }
                                        return offerId;
                                    });
                            }
                        }
                    }],
                    targets:
                    [{
                        type: 'form',
                        key: constants.FIELD.OFFER_ID,
                        pluralKey: constants.FIELD.OFFER_ID + 's'
                    },
                    {
                        type: 'form',
                        key: constants.FIELD.PURCHASEINFO_OFFERID,
                        pluralKey: constants.FIELD.PURCHASEINFO_OFFERID + 's'
                    }]
                };

                return dispatcher.dispatch(
                {
                    items: items,
                    timeout: 1000 * 60 * 60
                });
            });
    };

    return Ctor;
});    
